import { render } from "./responsible-persons-chooser.vue?vue&type=template&id=3f372999"
import script from "./responsible-persons-chooser.vue?vue&type=script&setup=true&lang=js"
export * from "./responsible-persons-chooser.vue?vue&type=script&setup=true&lang=js"

import "./responsible-persons-chooser.vue?vue&type=style&index=0&id=3f372999&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/responsible-persons-chooser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f372999"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f372999', __exports__)) {
    api.reload('3f372999', __exports__)
  }
  
  module.hot.accept("./responsible-persons-chooser.vue?vue&type=template&id=3f372999", () => {
    api.rerender('3f372999', render)
  })

}


export default __exports__